import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.jsx';
import './index.css';
// import { HelmetProvider } from 'react-helmet-async';
import { initializeAuth } from './utils/crossTabAuth.js';

// Initialize auth state and setup cross-tab communication
initializeAuth();

ReactDOM.hydrateRoot(
  document.getElementById('root'),
  <React.StrictMode>
    {/* <HelmetProvider> */}
      <App />
    {/* </HelmetProvider> */}
  </React.StrictMode>
);